import {
  AuthActionTypes,
  AuthAction,
} from '../authActionTypes';
import {CurrentUserDetails} from '../../../../common/types';

export type AuthState = {
  token: string | null,
  user: CurrentUserDetails | null,
}

const defaultState: AuthState = {
  token: null,
  user: null
};

const reducer = (
  state: AuthState = defaultState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case AuthActionTypes.SET_TOKEN:
      return {...state, token: action.payload};

    case AuthActionTypes.SET_USER:
      return {...state, user: action.payload};

    case AuthActionTypes.LOGOUT:
      return defaultState;

    default:
      return state;
  }
};

export default reducer;
